<template>
  <v-container fluid class="background">
    <v-row class="my-4 pt-6 mb-0 pb-0">
      <v-col cols="12" class="pl-2 ml-2" align="center">
        <span class="font-24 text-4376D8 w-700 font-text"
          >ยืนยันตัวตนด้วยเบอร์โทรศัพท์</span
        >
        <v-img
          :src="require(`@/assets/img/img-otp.svg`)"
          class="mb-1 my-4 size-img"
        />
      </v-col>
      <v-col cols="12" align="center">
        <span class="font-18"
          >ระบบได้ส่งรหัสยืนยัน (OTP) 6 หลัก ไปยังเบอร์
          <span class="text-4376D8">{{ mobile }}</span> กรุณาตรวจสอบ SMS
          และกรอกรหัสเพื่อยืนยันตัวตน</span
        ></v-col
      >
      <v-col cols="12">
        <div>
          <div class="ma-auto position-relative" style="max-width: 300px">
            <v-otp-input
              v-model="otp"
              :disabled="loading"
              ref="otpInput"
              @finish="ConfirmedOtp()"
            ></v-otp-input>
            <v-overlay absolute :value="loading">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-overlay>
          </div>
        </div>
      </v-col>
      <v-col align="center" cols="12">
        <div class="d-flex flex-column">
          <span>Ref: {{ Ref_code }}</span>
          <span v-if="timeOtp > 0" class="text-red pt-2"
            >ขอ OTP ได้อีกครั้งภายใน {{ timeOtp }} วินาที</span
          >
          <span v-else class="text-red pt-2">ขอ OTP ใหม่อีกครั้ง</span>
        </div></v-col
      >
    </v-row>
    <v-row class="d-flex justify-center my-2"
      ><v-col cols="2" class="d-flex justify-center">
        <v-btn
          v-if="solution == 'register'"
          block
          depressed
          color="#F0F0F0"
          type="submit"
          :disabled="timeOtp > 0"
          @click="ResetOtp()"
          style="border-radius: 12px; width: 150px; height: 40px"
          ><span>ขอ OTP อีกครั้ง</span></v-btn
        >
        <v-btn
          v-if="solution == 'login'"
          block
          depressed
          color="#F0F0F0"
          type="submit"
          :disabled="timeOtp > 0"
          @click="resetLoginOtp()"
          style="border-radius: 12px; width: 150px; height: 40px"
          ><span>ขอ OTP อีกครั้ง</span></v-btn
        >
        <div class="px-2"></div>
        <v-btn
          block
          depressed
          color="#32B1EE"
          :loading="btn_loading"
          type="submit"
          style="border-radius: 12px; width: 150px; height: 40px"
          :disabled="otp.length < 6"
          @click="ConfirmedOtp()"
          ><span class="text-white">ยืนยัน OTP</span></v-btn
        ></v-col
      ></v-row
    >
    <v-overlay v-if="dialog_loading" persistent width="300">
      <v-progress-circular
        :size="70"
        :width="7"
        color="#2EA3DB"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    snackbar: false,
    btn_loading: false,
    dialog_loading: true,
    otp: "",
    mobile: "",
    Ref_code: "",
    solution: "",
    timeOtp: 60,
    timer: null,
    mobile_ref_id: "",
    line_user_id: "",
  }),
  async created() {
    this.mobile = this.$route.query.mobile;
    this.Ref_code = this.$route.query.ref_code;
    this.solution = this.$route.query.solution;
    this.mobile_ref_id = this.$route.query.mobile_ref_id;
    this.line_user_id = this.$route.query.user_id;
    setTimeout(() => {
      this.dialog_loading = false;
    }, 2000);
  },
  mounted() {
    this.startCountdown();
    this.$nextTick(() => {
      const inputs = this.$refs.otpInput.$el.querySelectorAll("input");
      inputs.forEach((input) => {
        input.setAttribute("inputmode", "numeric");
        input.setAttribute("type", "tel");
      });
    });
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    ConfirmedOtp() {
      try {
        this.btn_loading = true;
        let data = {
          line_user_id: this.$route.query.user_id,
          solution: this.solution,
          mobile: this.mobile,
          otp: this.otp,
        };
        if (this.$route.query.solution == "register") {
          data.mobile_ref_id = this.mobile_ref_id;
        }
        // console.log("🚀 ~ ConfirmedOtp() ~ data:", data);
        this.axios
          .post(
            `${process.env.VUE_APP_BACKEND_URL}/v1/lineoa/register-patient-otp`,
            data
          )
          .then((res) => {
            if (res.status == 200 && res.data) {
              this.$router.push(
                `/management/${this.$route.query.from}?type=${this.$route.query.type}`
              );
            } else {
              this.$swal.fire({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                timer: 3000,
                showConfirmButton: false,
                showCloseButton: false,
              });
            }
            this.btn_loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.btn_loading = false;
            if (
              err.response &&
              err.response.status === 500 &&
              err.response.data.message == "OTP Invalid."
            ) {
              this.$swal.fire({
                icon: "error",
                html: `
              <span style="color: black; font-size: 24px; font-family: Sarabun, sans-serif;">
                <strong>รหัส OTP ที่คุณป้อนไม่ถูกต้อง</strong>
              </span><br><br>
              <span style="color: black; font-size: 20px; font-family: Sarabun, sans-serif; padding-bottom: 14px; display: inline-block;">
                กรุณาตรวจสอบและลองใหม่อีกครั้ง
              </span>
              `,
                timer: 4000,
                showConfirmButton: false,
                showCloseButton: false,
              });
            } else {
              this.$swal.fire({
                icon: "error",
                html: `
              <span style="color: black; font-size: 24px; font-family: Sarabun, sans-serif;">
                <strong>เกิดข้อผิดพลาด</strong>
              </span><br><br>
              <span style="color: black; font-size: 20px; font-family: Sarabun, sans-serif; padding-bottom: 14px; display: inline-block;">
                กรุณาตรวจสอบและลองใหม่อีกครั้งในภายหลัง
              </span>
              `,
                timer: 3000,
                showConfirmButton: false,
                showCloseButton: false,
              });
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    ResetOtp() {
      try {
        let data = localStorage.getItem("itemRegister");
        if (data) {
          data = JSON.parse(data);
        }
        this.axios
          .post(
            `${process.env.VUE_APP_BACKEND_URL}/v1/lineoa/register-patient`,
            data
          )
          .then((res) => {
            if (res.status == 200 && res.data.result == "success") {
              this.Ref_code = res.data.data.responseFromOneid.data.refcode;
              this.mobile_ref_id =
                res.data.data.responseFromOneid.data.mobile_ref_id;
              if (res.data.message == "Register Oneid success.") {
                console.log("Register Oneid success.");
                this.otp = "";
              } else if (
                res.data.message == "Mobile number is already exists in Oneid."
              ) {
                console.log("Mobile number is already exists in Oneid.");
              }
            }
          });
      } catch (err) {
        console.err();
        this.$swal.fire({
          icon: "success",
          title: "เกิดข้อผิดพลาด",
          timer: 3000,
          showConfirmButton: false,
          showCloseButton: false,
        });
      }
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.timeOtp > 0) {
          this.timeOtp -= 1;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    TimeOtp() {
      this.timeOtp = 60;
      this.startCountdown();
    },
    resetLoginOtp() {
      try {
        const params = new URLSearchParams();
        params.append("line_user_id", this.line_user_id);
        this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/lineoa/check-patient?${params}`
          )
          .then(async (res) => {
            console.log("🚀 ~ .then ~ res:", res.data);
            if (res.data.result == "success") {
              this.Ref_code = res.data.data.responseFromOneid.data.refcode;
              this.otp = "";
            }
          });
      } catch (err) {
        console.error();
      }
    },
  },
};
</script>

<style scoped>
/* .otp-input {
  width: 50px;
  text-align: center;
  font-size: 20px;
} */
.size-img {
  width: 240px;
  height: 240px;
}

.position-relative {
  position: relative;
}

/* .background {
  background-image: url("../../assets/img/bg2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
  width: 100%;
  height: 100%;
} */
</style>
